export const PANEL_WIDTH = 200;
export const PANEL_WIDTH_LG = 240;

export const LG_MIN = 768;
